import { useWatch } from "react-hook-form";
import Stack from "@mui/material/Stack";
import NiyaazBookedSlotsInput from "./NiyaazBookedSlotsInput";
import { NiyaazFormLayout } from "./NiyaazFormLayout";
import {
  NiyaazCommentsSection,
  NiyaazCreatePaymentSection,
  NiyaazHofSection,
  NiyaazPayableSummary,
  NiyaazPeopleSection,
  NiyaazPreviousHistorySection,
  NiyaazTakhmeenSection,
  useIsAsharaNiyaazForm,
} from "./NiyaazFormSections";
import { useNiyaazFormEffects } from "./use-niyaaz-form-effects";

type NiyaazFormProps = {
  mode: "create" | "edit";
};

export const NiyaazForm = ({ mode }: NiyaazFormProps) => {
  const isCreate = mode === "create";
  const { currentEvent, payable } = useNiyaazFormEffects({
    syncTotal: isCreate,
    setPirsaWhenEnabled: true,
    resetPirsaWhenDisabled: !isCreate,
  });

  const isAshara = useIsAsharaNiyaazForm(currentEvent);
  const previousHistory = useWatch({ name: "previousHistory" });

  return (
    <NiyaazFormLayout
      hof={<NiyaazHofSection isAshara={isAshara} showLookup />}
      people={<NiyaazPeopleSection isAshara={isAshara} />}
      sidebarExtra={
        isCreate && previousHistory != null ? <NiyaazPreviousHistorySection /> : undefined
      }
      main={
        <Stack spacing={2.5}>
          <NiyaazTakhmeenSection isAshara={isAshara} pirsaDefaultValue={isCreate ? 1 : undefined} />
          <NiyaazPayableSummary payable={payable} />
          {isCreate ? <NiyaazCreatePaymentSection /> : null}
          <NiyaazCommentsSection />
          <NiyaazBookedSlotsInput />
        </Stack>
      }
    />
  );
};
